import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef } from 'react';
import { normalizeBearerToken } from 'shared/api/cms-access-token';
import { useIframeHostAuth } from './use-iframe-host-auth';
import CmsTokenBootstrap from './cms-token-bootstrap';
const IframeCmsShell = () => {
    const { auth, status, error } = useIframeHostAuth();
    const walletTokenRef = useRef('');
    const walletApiBaseRef = useRef(undefined);
    if (auth?.walletAccessToken) {
        walletTokenRef.current = auth.walletAccessToken;
        walletApiBaseRef.current = auth.walletApiBase;
    }
    const getWalletAccessToken = useCallback(() => normalizeBearerToken(walletTokenRef.current), []);
    if (status === 'error') {
        return (_jsxs("div", { className: "cms-iframe-shell cms-iframe-shell--error", children: [_jsx("p", { children: error ?? 'Failed to receive wallet access token from host.' }), _jsx("p", { className: "cms-iframe-shell__hint", children: "The host app must postMessage a wallet JWT for account, customer, and currency APIs." })] }));
    }
    if (status !== 'ready' || !auth) {
        return (_jsxs("div", { className: "cms-iframe-shell cms-iframe-shell--waiting", children: [_jsx("i", { className: "pi pi-spin pi-spinner cms-iframe-shell__spinner", "aria-hidden": true }), _jsx("p", { children: "Waiting for wallet access token from host\u2026" })] }));
    }
    return (_jsx(CmsTokenBootstrap, { getWalletAccessToken: getWalletAccessToken, walletApiBase: walletApiBaseRef.current }));
};
export default IframeCmsShell;
